import { queryOptions } from '@tanstack/react-query'
import { ApiError, employeeRequest } from '@/shared/api'
import { EmployeeMeResponseSchema, type Session, sessionFromMe } from '../model/types'

export const sessionKeys = {
  me: ['session', 'me'] as const,
}

// 401 у /api/employees/me = «не залогинен» → session null (не ошибка): _app
// beforeLoad уводит на id.stit.tech/auth/login. Прочие ошибки пробрасываем.
export const sessionQueryOptions = queryOptions({
  queryKey: sessionKeys.me,
  queryFn: async (): Promise<Session | null> => {
    try {
      const body = await employeeRequest<unknown>({ method: 'GET', path: '/employees/me' })
      return sessionFromMe(EmployeeMeResponseSchema.parse(body).data)
    } catch (error) {
      if (error instanceof ApiError && error.isUnauthorized) return null
      throw error
    }
  },
  staleTime: 60_000,
})
